var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloud = function SvgCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.25 9.143a7.002 7.002 0 0 1 13.5 0A5.502 5.502 0 0 1 17.5 20h-11A5.5 5.5 0 0 1 5.25 9.143M12 6a5 5 0 0 0-4.933 4.182 1 1 0 0 1-.895.833A3.5 3.5 0 0 0 6.5 18h11a3.5 3.5 0 0 0 .328-6.985 1 1 0 0 1-.895-.833A5 5 0 0 0 12 6",
    clipRule: "evenodd"
  })));
};
export default SvgCloud;